import type { QueryClient } from '@tanstack/react-query';
import type { ConversationId, Seq } from '@cyphex/types';
import { patchConversationEverywhere } from './conversationCache';

/** Local read-through: clears the badge the instant the user reaches the bottom. */
export function clearUnread(client: QueryClient, conversationId: ConversationId, seq: Seq): void {
  patchConversationEverywhere(client, conversationId, (conversation) => ({
    ...conversation,
    self: {
      ...conversation.self,
      lastReadSeq: Math.max(conversation.self.lastReadSeq, seq),
      unreadCount: 0,
      unreadMentionCount: 0,
      firstUnreadSeq: null,
    },
  }));
}

/** Applies a remote member's read receipt so the tick marks update live. */
export function applyReceipt(
  client: QueryClient,
  conversationId: ConversationId,
  userId: string,
  seq: Seq,
): void {
  patchConversationEverywhere(client, conversationId, (conversation) => ({
    ...conversation,
    members: conversation.members.map((member) =>
      member.user.id === userId ? { ...member, lastReadSeq: seq } : member,
    ),
  }));
}
